import { render } from "./BotStats.vue?vue&type=template&id=0dff2a6b"
import script from "./BotStats.vue?vue&type=script&lang=js"
export * from "./BotStats.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__